<template>
  <div id="app">
    <router-view />
    <axios-res></axios-res>
  </div>
</template>

<script>
import "./assets/css/iconfont.css";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    watchWindowSize() {
      var hh = window.screen.height;
      var h = document.body.offsetHeight;
      if (!window.screenTop && !window.screenY) {
        //非全屏
        this.$store.state.isFullScreen = false;
      }else{
        //全屏
        this.$store.state.isFullScreen = true;
      }

    },
  },
  mounted() {
    window.addEventListener("resize", this.watchWindowSize);
  },
};
</script>





// WEBPACK FOOTER //
// src/App.vue